/* ============================================
   SETTECINQUANTA — Hero Video Playlist
   Crossfade video + synchronized text transitions
   Apple-level cinematic hero
   ============================================ */
(function () {
  'use strict';

  var hero = document.querySelector('.sc-vhero');
  if (!hero) return;

  var videos = hero.querySelectorAll('.sc-vhero__video');
  var slides = JSON.parse(hero.dataset.slides || '[]');
  var titleEl = hero.querySelector('.sc-vhero__title');
  var subEl = hero.querySelector('.sc-vhero__sub');
  var ctaEl = hero.querySelector('.sc-vhero__cta');
  var dots = hero.querySelectorAll('.sc-vhero__dot');
  var current = 0;
  var transitioning = false;
  var autoTimer = null;
  var AUTO_INTERVAL = 7000;

  function go(next) {
    if (transitioning || next === current || next < 0 || next >= slides.length) return;
    transitioning = true;

    var prev = current;
    current = next;

    // Video crossfade
    videos[next].currentTime = 0;
    videos[next].play().catch(function () {});
    videos[next].classList.add('is-active');
    videos[prev].classList.add('is-leaving');

    // Text slide-up out
    titleEl.classList.add('is-leaving');
    subEl.classList.add('is-leaving');
    ctaEl.classList.add('is-leaving');

    // Dots
    dots[prev] && dots[prev].classList.remove('is-active');
    dots[next] && dots[next].classList.add('is-active');

    setTimeout(function () {
      // Update text content
      titleEl.textContent = slides[next].title;
      subEl.textContent = slides[next].sub;
      ctaEl.textContent = slides[next].cta;
      ctaEl.href = slides[next].href;

      // Remove leaving, add entering
      titleEl.classList.remove('is-leaving');
      subEl.classList.remove('is-leaving');
      ctaEl.classList.remove('is-leaving');
      titleEl.classList.add('is-entering');
      subEl.classList.add('is-entering');
      ctaEl.classList.add('is-entering');
    }, 380);

    setTimeout(function () {
      videos[prev].classList.remove('is-active', 'is-leaving');
      videos[prev].pause();

      titleEl.classList.remove('is-entering');
      subEl.classList.remove('is-entering');
      ctaEl.classList.remove('is-entering');
      transitioning = false;
    }, 900);

    resetAuto();
  }

  function advance() {
    go((current + 1) % slides.length);
  }

  function resetAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(advance, AUTO_INTERVAL);
  }

  // Click anywhere on hero advances
  hero.addEventListener('click', function (e) {
    if (e.target.closest('.sc-vhero__cta') || e.target.closest('.sc-vhero__dot')) return;
    advance();
  });

  // Dot click
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function (e) {
      e.stopPropagation();
      go(i);
    });
  });

  // Arrow nav
  var arrowR = hero.querySelector('.sc-vhero__arrow--next');
  var arrowL = hero.querySelector('.sc-vhero__arrow--prev');
  if (arrowR) arrowR.addEventListener('click', function (e) { e.stopPropagation(); advance(); });
  if (arrowL) arrowL.addEventListener('click', function (e) { e.stopPropagation(); go((current - 1 + slides.length) % slides.length); });

  // Keyboard
  hero.setAttribute('tabindex', '0');
  hero.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' || e.key === ' ') { e.preventDefault(); advance(); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go((current - 1 + slides.length) % slides.length); }
  });

  // Init first video
  videos[0].classList.add('is-active');
  videos[0].play().catch(function () {});
  dots[0] && dots[0].classList.add('is-active');

  // Pause auto on hover (desktop)
  hero.addEventListener('mouseenter', function () { clearInterval(autoTimer); });
  hero.addEventListener('mouseleave', resetAuto);

  // Pause when not visible
  var obs = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      videos[current].play().catch(function () {});
      resetAuto();
    } else {
      videos[current].pause();
      clearInterval(autoTimer);
    }
  }, { threshold: 0.3 });
  obs.observe(hero);

  resetAuto();
})();
